import React from "react";

export const preventNonNumericalInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (!e.key.match(/^[0-9.]+$/)) {
    e.preventDefault();
  }
};
